// @flow
import React from 'react';
import { Label } from 'semantic-ui-react';

import { StyledPopup } from '../../common-utils/styledComponents';

export const LabelWithPopup = ({
  labelText,
  popupTooltipText,
  labelRibbon,
  labelColor,
  labelStyle,
  popupPosition,
  popupSize,
}) => (
  <StyledPopup
    content={popupTooltipText}
    disabled={!popupTooltipText} // If TooltipText is empty, don't show the popup
    position={popupPosition}
    size={popupSize}
    trigger={
      <Label color={labelColor} ribbon={labelRibbon} style={labelStyle}>
        {labelText}
      </Label>
    }
  />
);
